import { QRCodeSVG } from 'qrcode.react'
import { PRINT_LOGO_SRC } from '~/features/events/checkin-flyer/flyer-content'
import { cn } from '~/shared/lib/utils'
import type { FollowFlyerContent } from '../lib/follow-flyer-content'

/** A plain white sheet: the organizer, why to follow, a large QR code and the Pulsify wordmark. */
export function FollowFlyer({
  content,
  className,
}: {
  content: FollowFlyerContent
  className?: string
}) {
  return (
    <div
      className={cn(
        '@container overflow-hidden bg-print-paper text-center text-print-ink',
        className,
      )}
    >
      <div className="flex size-full flex-col items-center px-[11cqw] pt-[10cqw] pb-[8cqw]">
        <span className="grid size-[17cqw] shrink-0 place-items-center overflow-hidden rounded-full border-[0.4cqw] border-print-ink/15 font-semibold font-serif text-[7cqw]">
          {content.avatarUrl ? (
            <img src={content.avatarUrl} alt="" className="size-full object-cover" />
          ) : (
            content.initial
          )}
        </span>
        <h1 className="mt-[4cqw] line-clamp-2 shrink-0 font-serif text-[7.6cqw] leading-[1.12] font-semibold break-words">
          {content.headline}
        </h1>
        <p className="mt-[2.6cqw] shrink-0 text-[3.6cqw] leading-snug text-print-ink/75">
          {content.tagline}
        </p>
        <div className="flex flex-1 flex-col items-center justify-center gap-[3cqw] py-[4cqw]">
          <QRCodeSVG value={content.url} marginSize={0} className="block size-[52cqw]" />
          <p className="text-[2.8cqw] font-semibold tracking-[0.14em] uppercase">
            {content.fineprint}
          </p>
        </div>
        <img src={PRINT_LOGO_SRC} alt="" className="h-[7cqw] w-auto" />
      </div>
    </div>
  )
}
